
import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {
    Container,
    Jumbotron
    
}from 'reactstrap';

export default class Home extends Component {
  render() {
    return (
      <div>
        
            <Jumbotron id="contactDiv">
                <h1>Contact Us Today For A Wonderful Experience!</h1>
                <p>Call (254) 339-1359</p>
                <p>We are located at 1220 Dutton Ave, Waco, TX 76706</p>               
            </Jumbotron>
            <Container className="text-center">
              <a href="https://www.google.com/maps/place/Tortilleria+Rio/@31.5426875,-97.1294115,15z/data=!4m5!3m4!1s0x0:0xfb7d9652e77f191b!8m2!3d31.5426875!4d-97.1294115" target="_blank"><img className="img-fluid" alt="map" src="./images/mapPic.png"/></a>
            </Container>
        
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Contact.js